import { getShopifyProductId } from "./metadata";

const VISITOR_ID_KEY = "socialocean_visitor_id";

export function generateUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getVisitorId(): string {
  if (typeof window === "undefined") return "";

  let visitorId = localStorage.getItem(VISITOR_ID_KEY);
  if (!visitorId) {
    visitorId = generateUUID();
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }
  return visitorId;
}

export type EventType =
  | "reviews.widget_viewed"
  | "reviews.modal_opened"
  | "reviews.modal_closed"
  | "reviews.widget_scrolled"
  | "favorites.added"
  | "favorites.removed"
  | "reviews.filter_chip_tapped"
  | "reviews.review_liked"
  | "reviews.review_unliked";

export type ModalOpenSource =
  | "show_all_button"
  | "star_badge"
  | "chip"
  | "other_external";

function abProps(): Record<string, unknown> {
  const ab = (window as any).__SO_AB__;
  if (!ab || (ab.variant !== "control" && ab.variant !== "treatment")) return {};
  return { ab_variant: ab.variant, experiment_key: ab.experiment, excluded: !!ab.excluded };
}

export function trackEvent(
  eventType: EventType,
  params?: {
    clientSideId?: string;
    duration?: number;
    source?: ModalOpenSource;
    chip?: string;
    surface?: "carousel" | "sheet";
    // Identify a liked/unliked review by its server id (plus name/rating for
    // readability in the analytics stream).
    reviewId?: number;
    reviewName?: string;
    rating?: number;
  }
) {
  try {
    if (!window.Shopify?.analytics?.publish) return;

    const visitorId = getVisitorId();
    if (!visitorId) return;

    const productId = getShopifyProductId();
    const url = window.location.href;

    const ab = abProps();
    const payload = {
      visitorId,
      url,
      productId,
      ...params,
      // Nest A/B keys under `properties` so the pixel forwards them where the
      // backend reads them (properties.ab_variant). Omitted when not bucketed.
      ...(Object.keys(ab).length > 0 ? { properties: ab } : {}),
    };

    window.Shopify.analytics.publish(eventType, payload);
  } catch (error) {
    console.error("Failed to track event:", error);
  }
}
